import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { UserPhone } from 'src/app/models/UserPhone';
@Injectable({
    providedIn: 'root'
})
export class UserPhoneApi extends Api<UserPhone> {
}
